// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"421f4d5b","378":"ae8b9f7b"}[chunkId] + ".chunk.js";
};